/* Basket free-delivery picks (31 Oct 2026). See snippets/pv-basket-picks.liquid.
   Under the theme's "Spend £X more to reach free shipping" bar, offers one or two products
   that close the gap to the free-delivery threshold, with a one-tap Add button.
   Rules: never a product already in the basket, or one sharing a main ingredient with it
   (see KEYS); men's products only if the basket already has one, and the same for women's; in stock and not subscription-only.
   Prefers products that PAIR with what is in the basket (see PAIRS, labelled "Pairs with your
   iron" etc.): first the cheapest pairing product that reaches the threshold, then the
   best-matching pairing product (often a single). If nothing pairs, falls back to the cheapest
   product that reaches the threshold. Hidden once the basket reaches the
   threshold, and the theme's own "You may also like" row shows again. */
(function () {
  'use strict';
  var data = null, loading = null, lastCart = null, lastSig = '', busy = false, timer = null;
  var CACHE_KEY = 'pvUps1';
  var KEYS = ['iron', 'biotin', 'collagen', 'magnesium', 'd3', 'b12', 'zinc', 'nmn', 'nad+', 'probiotic', 'ashwagandha', 'omega', 'creatine', 'turmeric', 'milk thistle', 'mane', 'maca'];
  // What pairs well with what is already in the basket (by main ingredient). Edit freely:
  // a basket ingredient on the left, the ingredients worth suggesting with it on the right,
  // strongest pairing first. ('mane' = lion's mane: matching on lion would also hit dandelion.)
  var PAIRS = {
    'iron': ['b12', 'd3', 'probiotic', 'zinc'],
    'b12': ['iron', 'd3', 'magnesium', 'mane'],
    'd3': ['magnesium', 'zinc', 'omega', 'probiotic'],
    'magnesium': ['ashwagandha', 'd3', 'b12', 'omega'],
    'ashwagandha': ['magnesium', 'b12', 'mane'],
    'mane': ['omega', 'b12', 'ashwagandha', 'magnesium'],
    'omega': ['d3', 'magnesium', 'turmeric', 'mane'],
    'biotin': ['collagen', 'zinc'],
    'collagen': ['biotin', 'zinc'],
    'zinc': ['probiotic', 'd3', 'biotin'],
    'probiotic': ['zinc', 'milk thistle', 'd3'],
    'milk thistle': ['turmeric', 'probiotic'],
    'turmeric': ['omega', 'collagen', 'milk thistle', 'creatine'],
    'creatine': ['magnesium', 'omega', 'collagen', 'turmeric'],
    'nmn': ['magnesium', 'omega', 'd3'],
    'nad+': ['magnesium', 'omega', 'b12'],
    'maca': ['zinc', 'magnesium', 'omega', 'd3']
  };
  var LABEL = { 'iron': 'iron', 'b12': 'B12', 'd3': 'vitamin D3', 'magnesium': 'magnesium', 'ashwagandha': 'ashwagandha', 'mane': "lion's mane", 'omega': 'omega-3', 'biotin': 'biotin', 'collagen': 'collagen', 'zinc': 'zinc', 'probiotic': 'probiotic', 'milk thistle': 'milk thistle', 'turmeric': 'turmeric', 'creatine': 'creatine', 'nmn': 'NMN', 'nad+': 'NAD+', 'maca': 'MANS PRIME' };

  function money(c) { return '£' + (c / 100).toFixed(2); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]; }); }

  function threshold() {
    var el = document.querySelector('free-shipping-goal');
    var m = el ? Number(el.getAttribute('data-minimum-amount')) : 35;
    if (!m || isNaN(m)) m = 35;
    var rate = Number((window.Shopify && Shopify.currency && Shopify.currency.rate) || 1) || 1;
    return Math.round(m * rate * 100);
  }

  function loadData() {
    if (data) return Promise.resolve(data);
    if (loading) return loading;
    try {
      var c = sessionStorage.getItem(CACHE_KEY);
      if (c) { var o = JSON.parse(c); if (o && Date.now() - o.t < 600000 && o.d && o.d.length) { data = o.d; return Promise.resolve(data); } }
    } catch (e) {}
    loading = fetch('/?sections=pv-upsell-data', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var doc = new DOMParser().parseFromString(j['pv-upsell-data'] || '', 'text/html');
        var s = doc.getElementById('pv-ups-data');
        data = s ? JSON.parse(s.textContent) : [];
        try { sessionStorage.setItem(CACHE_KEY, JSON.stringify({ t: Date.now(), d: data })); } catch (e) {}
        return data;
      })
      .catch(function () { loading = null; return []; });
    return loading;
  }

  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function pick(cart, list) {
    var gap = threshold() - (cart.items_subtotal_price || 0);
    if (!cart.item_count || gap <= 0) return { items: [] };
    var inCart = {}, men = {}, hasMen = false;
    list.forEach(function (p) { if (p.men) men[p.h] = 1; });
    (cart.items || []).forEach(function (i) { inCart[i.handle] = 1; if (men[i.handle]) hasMen = true; });
    var base = list.filter(function (p) { return p.ok && p.p > 0 && p.vid && !inCart[p.h] && (!p.men || hasMen); });
    // Skip anything that shares a main ingredient with the basket (no second iron, no D3 twice).
    var cartText = (cart.items || []).map(function (i) { return String(i.product_title || i.title || '').toLowerCase(); }).join(' | ');
    var used = KEYS.filter(function (k) { return cartText.indexOf(k) > -1; });
    var forWomen = cartText.indexOf('women') > -1;
    var c = base.filter(function (p) {
      var t = String(p.t).toLowerCase();
      if (!forWomen && t.indexOf('women') > -1) return false; // women's products only if the basket has one
      return !used.some(function (k) { return t.indexOf(k) > -1; });
    });
    if (!c.length) c = base;
    c.sort(function (a, b) { return a.p - b.p || b.n - a.n; });
    // Related first: products that pair with an ingredient already in the basket.
    // Score = strength of the pairings found in the product (first in a PAIRS list = 4, then 3, 2, 1).
    var want = {};
    used.forEach(function (k) {
      (PAIRS[k] || []).forEach(function (r, i) {
        if (used.indexOf(r) > -1) return;
        var w = Math.max(1, 4 - i);
        if (!want[r] || want[r].w < w) want[r] = { k: k, w: w };
      });
    });
    c.forEach(function (p) {
      p.pair = null; p.score = 0;
      var t = String(p.t).toLowerCase(), best = 0;
      for (var r in want) { if (t.indexOf(r) > -1) { p.score += want[r].w; if (want[r].w > best) { best = want[r].w; p.pair = want[r].k; } } }
    });
    var related = c.filter(function (p) { return p.score > 0; });
    var close = c.filter(function (p) { return p.p >= gap; });
    var relClose = related.filter(function (p) { return p.p >= gap; });
    var strong = relClose.filter(function (p) { return p.score >= 2; });
    var out = [];
    // 1st: the cheapest pairing product that reaches the threshold (a strong pairing if there is one).
    var first = strong[0] || relClose[0] || null;
    if (first) out.push(first);
    // 2nd: the best-matching pairing product overall (often a single), even if it does not reach the threshold alone.
    var bestRel = related.slice().sort(function (a, b) { return b.score - a.score || a.p - b.p; }).filter(function (p) { return !first || p.h !== first.h; })[0];
    if (bestRel) out.push(bestRel);
    if (!out.length && close.length) out.push(close[0]);
    if (!out.length) out = c.slice().sort(function (a, b) { return b.p - a.p; }).slice(0, 4).sort(function (a, b) { return b.n - a.n; }).slice(0, 2);
    out = out.slice(0, 2);
    return { items: out, gap: gap, closes: !!(out[0] && out[0].p >= gap) };
  }

  function html(res) {
    var head = 'Goes well with your basket';
    var rows = res.items.map(function (p) {
      var stars = p.n > 0 ? '<span>★ ' + Number(p.r).toFixed(1) + ' (' + p.n + ')</span>' : '';
      return '<div class="pv-ups__item">' +
        '<a class="pv-ups__img" href="' + esc(p.u) + '" tabindex="-1" aria-hidden="true">' + (p.img ? '<img src="' + esc(p.img) + '" alt="" loading="lazy" width="48" height="48">' : '') + '</a>' +
        '<div class="pv-ups__info"><a class="pv-ups__title" href="' + esc(p.u) + '">' + esc(p.t) + '</a>' +
        (p.pair ? '<div class="pv-ups__pair">Pairs with your ' + esc(LABEL[p.pair] || p.pair) + '</div>' : '') +
        (p.p >= res.gap ? '<div class="pv-ups__free">✓ Gets you free UK delivery</div>' : '') +
        '<div class="pv-ups__meta"><span class="pv-ups__price">' + money(p.p) + '</span>' + stars + '</div></div>' +
        '<button type="button" class="pv-ups__add" data-pv-ups-add="' + esc(p.vid) + '" aria-label="Add ' + esc(p.t) + ' to basket">Add</button>' +
        '</div>';
    }).join('');
    return '<p class="pv-ups__head">' + head + '</p><div class="pv-ups__list">' + rows + '</div>';
  }

  function targets() {
    return Array.prototype.filter.call(document.querySelectorAll('free-shipping-goal'), function (g) {
      return g.closest('cart-drawer') || g.closest('main-cart') || g.closest('.cart') || document.body.classList.contains('template-cart') || location.pathname.replace(/\/$/, '') === '/cart';
    });
  }

  function render(cart, force) {
    if (!cart) return;
    lastCart = cart;
    var tg = targets();
    if (!tg.length) return;
    loadData().then(function (list) {
      var res = pick(cart, list || []);
      var sig = res.items.map(function (p) { return p.h; }).join(',') + '|' + (res.closes ? 1 : 0);
      var on = res.items.length > 0;
      document.documentElement.classList.toggle('pv-ups-on', on);
      tg.forEach(function (g) {
        var box = g.nextElementSibling && g.nextElementSibling.hasAttribute('data-pv-ups') ? g.nextElementSibling : null;
        if (!on) { if (box) box.remove(); return; }
        if (box && !force && sig === lastSig) return;
        if (!box) { box = document.createElement('div'); box.className = 'pv-ups'; box.setAttribute('data-pv-ups', ''); g.insertAdjacentElement('afterend', box); }
        box.innerHTML = html(res);
      });
      lastSig = sig;
    });
  }

  function add(btn) {
    if (busy) return;
    busy = true;
    var vid = Number(btn.getAttribute('data-pv-ups-add'));
    btn.disabled = true; btn.textContent = 'Adding…';
    var sections = [];
    try { document.documentElement.dispatchEvent(new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sections } })); } catch (e) {}
    fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: vid, quantity: 1 }], sections: sections })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.status) throw res;
        return getCart().then(function (cart) {
          var fx = window.FoxTheme;
          if (fx && fx.pubsub && fx.pubsub.PUB_SUB_EVENTS && res.sections && sections.length) {
            cart.sections = res.sections;
            fx.pubsub.publish(fx.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'pv-basket-picks', cart: cart });
            render(cart, true);
          } else {
            location.reload();
          }
        });
      })
      .catch(function () { location.href = '/cart'; })
      .then(function () { busy = false; });
  }

  function refresh() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      var tg = targets();
      if (!tg.length) return;
      var missing = tg.some(function (g) { return !(g.nextElementSibling && g.nextElementSibling.hasAttribute('data-pv-ups')); });
      if (lastCart && !missing) return;
      if (lastCart) { render(lastCart, true); return; }
      var total = Number(tg[0].getAttribute('data-cart-total') || 0);
      if (total <= 0 || total >= threshold()) return;
      getCart().then(function (c) { render(c, true); }).catch(function () {});
    }, 150);
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-pv-ups-add]');
    if (b) { e.preventDefault(); add(b); }
  });
  document.addEventListener('cart:updated', function (e) {
    var cart = e.detail && e.detail.cart;
    if (cart && typeof cart.items_subtotal_price === 'number' && cart.items) { render(cart, true); }
    else { getCart().then(function (c) { render(c, true); }).catch(function () {}); }
  });

  function init() {
    var drawer = document.querySelector('cart-drawer');
    var isCart = !!document.querySelector('main-cart free-shipping-goal, .cart free-shipping-goal') || location.pathname.replace(/\/$/, '') === '/cart';
    if (isCart) refresh();
    if (drawer) {
      new MutationObserver(function () { if (!drawer.hasAttribute('hidden') || drawer.hasAttribute('open')) refresh(); })
        .observe(drawer, { attributes: true, childList: true, subtree: true });
    }
    var mc = document.querySelector('main-cart');
    if (mc) new MutationObserver(refresh).observe(mc, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
